import { withType } from "../../../../utils/actionOperations";
import { APPLY_TREND_PAIRING, DISCARD_TREND_PAIRING, HANDLE_CHANGE_BECHMARK_FILTERING, HANDLE_CHANGE_COMPARISON_TOGGLE, HANDLE_CHANGE_TREND_BASELINE, HANDLE_CHANGE_TREND_MATCH_MODE, HANDLE_CHANGE_SAMPLE_COMMENTS_FILTER, REASSIGN_SAVED_DATA, RESET_ALL_STATE, RESET_TREND_PAIRING, SET_BENCHMARK_DATA_FETCHED, SET_TREND_DATA_FETCHED } from "../../../constants";

export const handleChangeBenchmarkFilter = (event) => {
    return dispatch => {
        dispatch(withType(HANDLE_CHANGE_BECHMARK_FILTERING, event));
    };
};

export const handleChangeSampleCommentsFilter = (event) => {
    return dispatch => {
        dispatch(withType(HANDLE_CHANGE_SAMPLE_COMMENTS_FILTER, event));
    };
};

export const resetState = (event) => {
    return dispatch => {
        dispatch(withType(RESET_ALL_STATE, event));
    };
};

export const resetFilterContentsFromSavedData = (event) => {
    return dispatch => {
        dispatch(withType(REASSIGN_SAVED_DATA, event));
    };
}

export const handleChangeComparisonToggle = (event) => {
    return dispatch => {
        dispatch(withType(HANDLE_CHANGE_COMPARISON_TOGGLE, event));
    };
}

// payload: { value } — true once the trend APIs have been fired for the filters
// on screen, false when Apply makes what's cached out of date. Toggling the
// comparison on reads this instead of re-fetching what's already in the store.
export const setTrendDataFetched = (event) => {
    return dispatch => {
        dispatch(withType(SET_TREND_DATA_FETCHED, event));
    };
}

// payload: { value } — the same, for the plain (non-trend) visualizations.
// Applying while the comparison is on fetches only the trend side, so this is
// what tells the comparison going off again that the view behind it is stale.
export const setBenchmarkDataFetched = (event) => {
    return dispatch => {
        dispatch(withType(SET_BENCHMARK_DATA_FETCHED, event));
    };
}

// Trend comparison pairing — kept in redux so it survives the comparison
// toggle unmounting the view.
// payload: { value, keepRows } — a MATCH_MODES value, and how many compared
// leaders to keep loaded (the rest are re-fetched on scroll).
export const handleChangeTrendMatchMode = (event) => {
    return dispatch => {
        dispatch(withType(HANDLE_CHANGE_TREND_MATCH_MODE, event));
    };
}

// payload: { projectId, value } — the leader's current 360 and the earlier 360
// picked as its baseline. Both are project ids: { current: baseline }.
export const handleChangeTrendBaseline = (event) => {
    return dispatch => {
        dispatch(withType(HANDLE_CHANGE_TREND_BASELINE, event));
    };
}

// No payload — puts the whole pairing back to its initial state, match mode and
// hand-picked baselines both. Dispatched when new filters are applied, since the
// rows those picks name may not be in the rebuilt lists at all.
export const resetTrendPairing = () => {
    return dispatch => {
        dispatch(withType(RESET_TREND_PAIRING, {}));
    };
}

// payload: { keepRows } — used if discarding switches the match mode back.
export const discardTrendPairing = (event) => {
    return dispatch => {
        dispatch(withType(DISCARD_TREND_PAIRING, event || {}));
    };
}

export const applyTrendPairing = () => {
    return dispatch => {
        dispatch(withType(APPLY_TREND_PAIRING, {}));
    };
}
